import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchTerm: "",
  displaySearchTerm: "",
  childFilterTerm: "",
  selectedCategory: "Principal Diagnosis",
  currentCodeSearchData: null,
  filteredCodes: [],
  selectedIndex: null,
  showFinalScreen: false,
  selectedFinalCode: null,
  initialSearchDone: false,
  selectedCodes: {
    "Principal Diagnosis": [],
    "Procedure Codes": [],
    "Additional Diagnoses": [],
  },
  showError: false,
  selectedParent: null,
  topLevelParent: null,
  lastAddedCode: null,
  originalCode: null,
  finalScreenRender: false,
  currentPath: [],
  history: [],
  historyIndex: -1,
  codePathHistory: [],
  tempPath: [],
  selectedCodebookValue: null,
  slectedParntesandChilds: null,
  chapter19Info: null,
  pendingDirectCode: null,
  pendingInjuryAfterInstructions: false,
  pendingInjuryCode: null,
  selectedCodeDetails: {
    category: null,
    value: null,
    isFromTabular: false,
    code_id: null,
  },
  finalShowScreen: false,
  arrivedViaBackToFinal: false,
  pendingInjuryAfterInstructions: false,
  pendingMorphologyFromHyphen: null,
  allHyphenCodesWithPendingMorphology: [],
  pendingManifestationAfterInstructions: false,
  manifestationWarningMessage: null,
  pathwaySnapshots: {}, // { [timestamp]: fullLocalStateSnapshot }
  pendingInjuryCode: null,
  navigationHistory: [],
  pendingInstructions: [],
  currentInstructionIndex: 0,
  currentWarningMessage: null,
  specialCodesToProcess: [],
  processingSpecialCodes: false,
  currentSpecialCodeIndex: 0,
  currentSpecialCode: "",
  originalSpecialCodesWithSymbols: [],
  // Range-based states
  injuryWithActivity: [], // S00 – T65
  externalCauseCodes: [], // V00 – Y91 and Y95-Y98
  placeOfOccurrence: [], // Y92.0 – Y92.89
  activityCodes: [], // U50.0 - U73.81
  injuryWithoutActivity: [],
  injuries: [],
  burns: [],
  frostbite: [],
  poisoning: [],
  effectsOfExternalCauses: [],
  earlyComplicationsOfTrauma: [],
  complicationOfSurgicalAndMedicalCare: [],
  otherComplicationOfTrauma: [],
  sequelaeOfInjuries: [],
  chronicCodes: [],
  rangesLoaded: {
    injuryWithActivity: false,
    externalCauseCodes: false,
    placeOfOccurrence: false,
    activityCodes: false,
    injuryWithoutActivity: false,
    injuries: false,
    burns: false,
    frostbite: false,
    poisoning: false,
    effectsOfExternalCauses: false,
    earlyComplicationsOfTrauma: false,
    complicationOfSurgicalAndMedicalCare: false,
    otherComplicationOfTrauma: false,
    sequelaeOfInjuries: false,
  },
  initialInjuryState: true,
  nextRangeToProcess: null,
  isInjuryWithoutActivityFlow: false,
  isInjuryWithActivity: false,
  currentInjuryRange: null,
  selectedInjuryCodes: null,
  showMoreInjuryPrompt: null,
  injuryFlowTracker: [],
  injuryCodeFlowTracker: [],
  finalRangeExecuted: false,
  currentClusterId: null,
  clusterHistory: [],
  chronicCodes: false,
  indexToTabularExtensions: [],
};

const codeSearchSlice = createSlice({
  name: "codeSearch",
  initialState,
  reducers: {
    updateLocalState: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetLocalState: (state) => {
      return { ...initialState, selectedCategory: state.selectedCategory };
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
    setInitialInjuryState: (state, action) => {
      state.initialInjuryState = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    setSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
    setFilteredCodes: (state, action) => {
      state.filteredCodes = action.payload;
    },
    setShowFinalScreen: (state, action) => {
      state.showFinalScreen = action.payload;
    },
    setInitialSearchDone: (state, action) => {
      state.initialSearchDone = action.payload;
    },
    setArrivedViaBackToFinal: (state, action) => {
      state.arrivedViaBackToFinal = action.payload;
    },
    setNextRangeToProcess: (state, action) => {
      state.nextRangeToProcess = action.payload;
    },
    addSelectedCode: (state, action) => {
      const { category, code } = action.payload;
      if (state.selectedCodes[category]) {
        state.selectedCodes[category].push(code);
      }
    },
    clearSelectedCodes: (state, action) => {
      const category = action.payload;
      if (state.selectedCodes[category]) {
        state.selectedCodes[category] = [];
      }
    },
    pushToCurrentPath: (state, action) => {
      state.currentPath.push(action.payload);
    },
    popFromCurrentPath: (state) => {
      state.currentPath.pop();
    },
    clearCurrentPath: (state) => {
      state.currentPath = [];
    },
    setDisplaySearchTerm: (state, action) => {
      state.displaySearchTerm = action.payload;
    },
    setChildFilterTerm: (state, action) => {
      state.childFilterTerm = action.payload;
    },
    // Add to your reducers
    setPendingInjuryAfterInstructions: (state, action) => {
      state.pendingInjuryAfterInstructions = action.payload;
    },
    setPendingInjuryCode: (state, action) => {
      state.pendingInjuryCode = action.payload;
    },
    setCurrentCodeSearchData: (state, action) => {
      state.currentCodeSearchData = action.payload;
    },
    setSelectedFinalCode: (state, action) => {
      state.selectedFinalCode = action.payload;
    },
    setSelectedCodebookValue: (state, action) => {
      state.selectedCodebookValue = action.payload;
    },
    handleStoreParentAndChilds: (state, action) => {
      state.slectedParntesandChilds = { ...action.payload };
    },
    pushToNavigationHistory: (state, action) => {
      state.navigationHistory.push(action.payload);
      console.log(state.navigationHistory, "state.navigationHistory");
    },
    popFromNavigationHistory: (state) => {
      if (state.navigationHistory.length > 0) {
        state.navigationHistory.pop();
      }
    },
    setIsInjuryWithoutActivityFlow: (state, action) => {
      state.isInjuryWithoutActivityFlow = action.payload;
    },
    clearNavigationHistory: (state) => {
      state.navigationHistory = [];
    },
    handleSelectedCodeDetails: (state, action) => {
      // payload: { category, value, isFromTabular }
      state.selectedCodeDetails = { ...action.payload };
      // console.log("Reducer received:", action.payload, state);
      // console.log(
      //   "Updated state.selectedCodeDetails:",
      //   state.selectedCodeDetails
      // );
    },
    handleResetSelectedDetails: (state) => {
      state.selectedCodeDetails = { ...initialState.selectedCodeDetails };
    },
    clearSelectedCodeDetails: (state) => {
      state.selectedCodeDetails = {};
    },

    // NEW REDUCERS: Instruction management
    resetInstructions: (state) => {
      state.pendingInstructions = [];
      state.currentInstructionIndex = 0;
      state.currentWarningMessage = null;
    },
    clearPendingInstructions: (state) => {
      state.pendingInstructions = [];
      state.currentInstructionIndex = 0;
    },
    setPendingInstructions: (state, action) => {
      state.pendingInstructions = action.payload;
    },
    setCurrentWarningMessage: (state, action) => {
      state.currentWarningMessage = action.payload;
    },
    clearWarningMessage: (state) => {
      state.currentWarningMessage = null;
    },

    // Updates the history stack
    updateHistory: (state, action) => {
      const newHistory = [
        ...state.history.slice(0, state.historyIndex + 1),
        action.payload,
      ];
      state.history = newHistory;
      state.historyIndex = newHistory.length - 1;
    },
    updateFinalScreenState: (state, action) => {
      state.finalShowScreen = action.payload; // update state
    },

    // Restores a state from a specific index in history
    restoreFromHistory: (state, action) => {
      const newIndex = action.payload;
      if (newIndex >= 0 && newIndex < state.history.length) {
        return {
          ...state,
          ...state.history[newIndex],
          historyIndex: newIndex,
        };
      }
    },
    setRangeChildren: (state, action) => {
      const { rangeType, children } = action.payload;
      state[rangeType] = children;
      state.rangesLoaded[rangeType] = true;
    },
    setRangeLoading: (state, action) => {
      state.loading = action.payload;
    },
    setRangeError: (state, action) => {
      state.error = action.payload;
    },
    clearRangeData: () => {
      state.injuryWithActivity = [];
      state.externalCauseCodes = [];
      state.placeOfOccurrence = [];
      state.activityCodes = [];
      state.injuryWithoutActivity = [];

      Object.keys(state.rangesLoaded).forEach((key) => {
        state.rangesLoaded[key] = false;
      });
    },

    // Reset the entire state
    resetState: () => initialState,

    // Reset search-related state without affecting codePathHistory
    resetSearchState: (state) => {
      return {
        ...state,
        searchTerm: "",
        displaySearchTerm: "",
        selectedCategory: "Principal Diagnosis",
        currentCodeSearchData: null,
        filteredCodes: [],
        selectedIndex: null,
        showFinalScreen: false,
        selectedFinalCode: null,
        initialSearchDone: false,
        history: [],
        historyIndex: -1,
        tempPath: [],
        // codePathHistory is not reset
      };
    },

    // Add reducer to update codePathHistory
    updateCodePathHistory: (state, action) => {
      // console.log("updateCodePathHistory reducer called with payload:", JSON.stringify(action.payload, null, 2));
      // console.log("Current codePathHistory before update:", JSON.stringify(state.codePathHistory, null, 2));
      state.codePathHistory = [...state.codePathHistory, action.payload];
      // console.log("Updated codePathHistory:", JSON.stringify(state.codePathHistory, null, 2));
    },
    // Add reducer to update tempPath
    updateTempPath: (state, action) => {
      state.tempPath = [...state.tempPath, action.payload];
    },

    // Add reducer to reset tempPath
    resetTempPath: (state) => {
      state.tempPath = [];
    },

    // Add reducer to clear codePathHistory
    clearCodePathHistory: (state) => {
      state.codePathHistory = [];
    },
    removeSecondLastFromHistory: (state) => {
      if (state.codePathHistory.length > 0) {
        state.codePathHistory.pop();
      }
      //  if (state.codePathHistory.length > 1) {
      //       state.codePathHistory.splice(-2, 1);
      //     } else if (state.codePathHistory.length === 1) {
      //       state.codePathHistory = [];
      //     }
    },
    // In your redux/codeSearchSlice.js, add:
    setCurrentInjuryRange: (state, action) => {
      state.currentInjuryRange = action.payload;
    },
    addToSelectedInjuryCodes: (state, action) => {
      state.selectedInjuryCodes = [
        ...state.selectedInjuryCodes,
        action.payload,
      ];
    },
    setShowMoreInjuryPrompt: (state, action) => {
      state.showMoreInjuryPrompt = action.payload;
    },
    setInjuryFlowTracker: (state, action) => {
      state.injuryFlowTracker = action.payload;
    },
    setInjuryCodeFlowTracker: (state, action) => {
      state.injuryCodeFlowTracker = action.payload;
    },
    // Add reducer
    setFinalRangeExecuted: (state, action) => {
      state.finalRangeExecuted = action.payload;
    },
    setCurrentClusterId: (state, action) => {
      state.currentClusterId = action.payload;
    },
    addToClusterHistory: (state, action) => {
      state.clusterHistory.push(action.payload);
    },
    resetClusterId: (state) => {
      state.currentClusterId = null;
    },
    setPendingInjuryAfterInstructions: (state, action) => {
      state.pendingInjuryAfterInstructions = action.payload;
    },
    setPendingInjuryCode: (state, action) => {
      state.pendingInjuryCode = action.payload;
    },
    setPendingMorphologyFromHyphen: (state, action) => {
      state.pendingMorphologyFromHyphen = action.payload;
    },

    setAllHyphenCodesWithPendingMorphology: (state, action) => {
      state.allHyphenCodesWithPendingMorphology = action.payload;
    },
    removeCurrentPathwayFromHistory: (state, action) => {
      const checkpointLength = action.payload; // length before current pathway started
      state.codePathHistory = state.codePathHistory.slice(0, checkpointLength);
    },
    setPendingManifestationAfterInstructions: (state, action) => {
      state.pendingManifestationAfterInstructions = action.payload;
    },
    setManifestationWarningMessage: (state, action) => {
      state.manifestationWarningMessage = action.payload;
    },
    clearManifestationState: (state) => {
  state.pendingManifestationAfterInstructions = false;
  state.manifestationWarningMessage = null;
},
savePathwaySnapshot: (state, action) => {
  const { timestamp, snapshot } = action.payload;
  if (!timestamp) return;
  state.pathwaySnapshots[timestamp] = snapshot;
},

restoreToPathwayStep: (state, action) => {
  const timestamp = action.payload;
  const snapshot = state.pathwaySnapshots[timestamp];
  if (!snapshot) return;

  // Truncate codePathHistory so nothing after the clicked step remains
  const idx = state.codePathHistory.findIndex((n) => n.timestamp === timestamp);
  if (idx !== -1) {
    state.codePathHistory = state.codePathHistory.slice(0, idx + 1);
  }

  // Rehydrate local state to exactly what it was at that step
  Object.assign(state, snapshot, {
    codePathHistory: state.codePathHistory, // keep truncated history, not the one in snapshot
  });

  // Drop snapshots for steps that no longer exist
  Object.keys(state.pathwaySnapshots).forEach((ts) => {
    if (new Date(ts) > new Date(timestamp)) {
      delete state.pathwaySnapshots[ts];
    }
  });
},
  },
});

export const {
  setCurrentInjuryRange,
  addToSelectedInjuryCodes,
  setShowMoreInjuryPrompt,
  setSearchTerm,
  setDisplaySearchTerm,
  setSelectedCategory,
  setFilteredCodes,
  setCurrentCodeSearchData,
  setSelectedIndex,
  setShowFinalScreen,
  setSelectedFinalCode,
  setInitialSearchDone,
  updateHistory,
  restoreFromHistory,
  resetState,
  resetSearchState,
  updateCodePathHistory,
  updateTempPath,
  resetTempPath,
  clearCodePathHistory,
  handleSelectedCodeDetails,
  handleResetSelectedDetails,
  updateFinalScreenState,
  handleStoreParentAndChilds,
  setChildFilterTerm,
  updateLocalState,
  resetLocalState,
  addSelectedCode,
  clearSelectedCodes,
  pushToCurrentPath,
  popFromCurrentPath,
  clearCurrentPath,
  pushToNavigationHistory,
  removeSecondLastFromHistory,
  popFromNavigationHistory,
  clearNavigationHistory,
  clearSelectedCodeDetails,
  resetInstructions,
  clearPendingInstructions,
  setPendingInstructions,
  setCurrentWarningMessage,
  clearWarningMessage,
  setArrivedViaBackToFinal,
  setRangeChildren,
  setRangeError,
  setRangeLoading,
  clearRangeData,
  setInitialInjuryState,
  setIsInjuryWithoutActivityFlow,
  setNextRangeToProcess,
  setInjuryFlowTracker,
  setInjuryCodeFlowTracker,
  setFinalRangeExecuted,
  setCurrentClusterId,
  addToClusterHistory,
  resetClusterId,
  setPendingInjuryAfterInstructions ,
  setPendingInjuryCode,
  setAllHyphenCodesWithPendingMorphology,
  setPendingMorphologyFromHyphen,
  removeCurrentPathwayFromHistory,
  setPendingManifestationAfterInstructions,
  setManifestationWarningMessage,
  clearManifestationState,
  savePathwaySnapshot,
  restoreToPathwayStep,
} = codeSearchSlice.actions;

export default codeSearchSlice.reducer;
